import ax from './customAxios';

const seguridadProvider = {
    login: async(usr, psw) => {
        const response = await ax.get('/seguridad', { params: { usr: usr, psw: psw } });
        if (response) {
            localStorage.setItem('token', response.token);
            return true;
        }
    },
    validarUsuario: async(val) => {
        const response = await ax.post('/seguridad/ValidarEmpleado', val);
        if (response) {
            localStorage.setItem('token', response.token);
            return true;
        }
    },
    ValidarEmpleadoCarnetVacunacion: async(val) => {
        const response = await ax.post('/seguridad/ValidarEmpleadoCarnetVacunacion', val);
        if (response) {
            localStorage.setItem('token', response.token);
            return true;
        }
    },


    validarCip: async(dni, fecha) => {
        return await ax.get('/seguridad/ValidarCip', { params: { dni: dni, fecha: fecha } });
    },
    validarLoginElecciones: async(dni, fecha, cip) => {
        const response = await ax.get('/seguridad/ValidarLoginElecciones', {
            params: {
                dni: dni,
                fecha: fecha,
                cip: cip
            }
        });
        if (response) {
            localStorage.setItem('token', response.token);
            return true;
        }
    },
    validarEstadoEleccion: async() => {
        return await ax.get('/seguridad/validarEstadoEleccion');
    },
    obtenerMenu: async() => {
        return await ax.get('/seguridad/ObtenerMenu');
    },
    obtenerRoles: async() => {
        return await ax.get('/seguridad/ObtenerRoles');
    },
    obtenerContacto: async(dni) => {
        return await ax.get('/seguridad/ObtenerContacto', { params: { dni: dni } });
    },
    obtenerUsuario: async(id) => {
        return await ax.get('/seguridad/ObtenerUsuario', { params: { id: id } });
    },
    guardarUsuario: async(usr) => {
        return await ax.post('/seguridad/RegistrarUsuario', usr);
    },
    cambiarContrasena: async(usr) => {
        return await ax.post('/seguridad/CambiarContraseña', usr);
    },
    permitirAcceso: async(usr) => {
        return await ax.post('/seguridad/PermitirAcceso', usr);
    },
    obtenerUsuarios: async(paginacion) => {
        return await ax.post('/seguridad/ObtenerUsuarios', paginacion);
    },
    logout: async() => {
        return await ax.get('/seguridad/Salir');
    },
    checkError: (error) => {
        const status = error.status;
        if (status === 401 || status === 403) {
            return Promise.reject();
        }
        return Promise.resolve();
    }
};

export default seguridadProvider;